import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PayTabsReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { PayTabsReport } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class PayTabsReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getPayTabsReport(filter: PayTabsReportFilterForm): Observable<DataWithPagination<PayTabsReport[]>> {
    return this.baseAPI.post(Constants.GET_PAY_TABS_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<PayTabsReport[]> = {
          data: this.mapper.fromListJson(PayTabsReport, res.items),
          count: res.count,
        };
        return data;
      })
    );
  }
}
